import React, { useState } from 'react';
import Button from '../../../assets/essentials/Button';
import { ComchekStatusResponse } from '../../../interfaces/comchek';
import PostQuery from '../../../api/internal/PostQuery';
import Input from '../../../assets/essentials/Input';

interface ComchekActionProps {
  action: 'status' | 'cancel';
  endpoint: string;
  buttonText: string;
  buttonVariant: 'good' | 'bad';
  onSuccess?: () => void;
}

export default function ComchekAction({
  action,
  endpoint,
  buttonText,
  buttonVariant,
  onSuccess
}: ComchekActionProps) {
  const [check, setCheck] = useState<ComchekStatusResponse | null>(null);
  const [error, setError] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setError('');
    setCheck(null);
    setIsLoading(true);

    const formData = new FormData(e.currentTarget);
    const checkNumber = formData.get('checkNumber');

    if (!checkNumber) {
      setError('Please enter an Express Check #.');
      setIsLoading(false);
      return;
    }

    PostQuery(endpoint, { ecn: checkNumber })
      .then(res => {
        if (res && res.data) {
          setCheck(res.data);
          onSuccess();
        } else {
          setError('No status found for this check number.');
        }
      })
      .catch(() => {
        setError(
          `Error ${
            action === 'cancel' ? 'canceling' : 'fetching status'
          }. Please try again.`,
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }

  return (
    <form onSubmit={handleSubmit}>
        <label htmlFor="checkNumber">Express Check #</label>
        <Input type="text" id="checkNumber" name="checkNumber" />
      <div>
        <Button type="submit" variant={buttonVariant} isLoading={isLoading} disabled={isLoading}>
          {buttonText}
        </Button>
      </div>
      {error && <div>{error}</div>}
      {check && (
        <div>
          <div>
            <strong>Status:</strong> {check.status}
          </div>
          <div>
            <strong>Response Message:</strong> {check.responseMessage}
          </div>
          <div>
            <strong>Express Check # (ECN):</strong> {check.ecn}
          </div>
          <div>
            <strong>Tracking #:</strong> {check.tracking}
          </div>
          <div>
            <strong>Amount:</strong> ${check.codeAmount?.toFixed(2)}
          </div>
          <div>
            <strong>Fee:</strong> ${check.codeFee?.toFixed(2)}
          </div>
          <div>
            <strong>Balance:</strong> ${check.balance?.toFixed(2)}
          </div>
          <div>
            <strong>Used Location:</strong> {check.usedLoc}
          </div>
          <div>
            <strong>Used Date (UTC):</strong> {check.usedDate}
          </div>
          <div>
            <strong>Status Checked (UTC):</strong> {check.statusChecked}
          </div>
        </div>
      )}
    </form>
  );
}
